import React from 'react';
import { Loader, BaasicTable, BaasicHeader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import ReactTooltip from 'react-tooltip';

const ChannelListTemplate = ({ viewStore, viewStore: { listStore, tableData, queryUtility, loading } }) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.ADMINISTRATION.CHANNELS"></BaasicHeader>
			<BaasicTable {...{ tableData, queryUtility, viewStore }} data={listStore.data.slice()} actions={viewStore} />
			<ReactTooltip />
		</section>
	);
};

export default defaultTemplate(ChannelListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/channel/pages/ChannelListTemplate.jsx